<!-- Section Header -->
<div class="tw-flex tw-gap-2 tw-items-center tw-w-full tw-px-4 tw-pt-4">
  @if (userPhoto()) {
    <div class="tw-size-12 tw-rounded-full tw-bg-gray-100 tw-overflow-hidden tw-shrink-0 tw-flex tw-items-center tw-justify-center">
      <img [src]="userPhoto()" alt="User photo" class="tw-size-12 tw-object-cover" />
    </div>
  }
  <div class="tw-flex tw-flex-col">
    <span class="tw-font-lexend tw-font-bold tw-text-400 tw-text-black" i18n="@@productsForUser">Products for {{ userName() }}</span>
    @switch (activeRegimenClass()) {
      @case (RegimenClass.Hair) {
        <span class="tw-font-body tw-text-100 tw-text-gray-500" i18n="@@fromDoctorHairKit">From doctor given hair treatment kit</span>
      }
      @case (RegimenClass.Both) {
        <span class="tw-font-body tw-text-100 tw-text-gray-500" i18n="@@fromDoctorSkinHairKit">From doctor given skin &amp; hair treatment kit</span>
      }
      @default {
        <span class="tw-font-body tw-text-100 tw-text-gray-500" i18n="@@fromDoctorKit">From doctor given skin treatment kit</span>
      }
    }
  </div>
</div>

<!-- Product Grid -->
<div class="tw-grid tw-grid-cols-2 tw-justify-items-center tw-gap-x-6 tw-gap-y-8 tw-px-4 tw-py-6">
  @for (product of products(); track product.objectId) {
    <app-product
      [product]="product"
      [productInCart]="productsInCart()[product.objectId]"
      [isShopRevampExperimentOn]="true"
      [size]="ProductSize.Medium"
      [isLocked]="product.isLocked"
      (addToCart)="onAddToCart($event)"
      (reomveFromCart)="onRemoveFromCart($event)"
      (gotoProduct)="onGotoProduct($event)">
    </app-product>
  }
</div>

<!-- Buy Complete Kit Banner -->
@if (regimens().length === 1) {
  <div class="tw-px-4 tw-pb-4">
    <app-buy-complete-kit-banner
      [regimen]="regimens()[0]"
      (buyKit)="onBuyKit($event)">
    </app-buy-complete-kit-banner>
  </div>
} @else if (regimens().length > 1) {
  <div class="tw-px-4 tw-pb-4">
    <swiper class="swiper-wrapper"
            [config]="{ slidesPerView: 1, spaceBetween: 20, threshold: 5, pagination: { el: '.kit-banner-pagination', clickable: true, renderBullet: renderBullet } }">
      @for (regimen of regimens(); track $index) {
        <app-buy-complete-kit-banner *swiperSlide
          [regimen]="regimen"
          (buyKit)="onBuyKit($event)">
        </app-buy-complete-kit-banner>
      }
    </swiper>
    <div class="kit-banner-pagination"></div>
  </div>
}
